import CryptoJS from 'crypto-js';

// 密钥生成和管理工具
export const EncryptionUtil = {
  // 生成随机密钥
  generateKey() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  },

  // 获取当前密钥（如果没有则生成）
  getKey() {
    let key = sessionStorage.getItem('encryptionKey');
    if (!key) {
      key = this.generateKey();
      sessionStorage.setItem('encryptionKey', key);
    }
    return key;
  },

  // 加密数据
  encrypt(data) {
    const key = this.getKey();
    const dataStr = JSON.stringify(data);
    return CryptoJS.AES.encrypt(dataStr, key).toString();
  },

  // 解密数据
  decrypt(encryptedData) {
    const key = this.getKey();
    const bytes = CryptoJS.AES.decrypt(encryptedData, key);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
};
